import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetHsCodes, CreateHsCode, UpdateHsCode, DeleteHsCode } from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const hsCodeQueryKeys = {
  hsCodes: () => ["hsCodes"] as const,
};

export const invalidateHsCodeQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: ["hsCodes"] });
};

export const useHsCodesQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: hsCodeQueryKeys.hsCodes(),
    queryFn: async () => unwrapApiResponse(await GetHsCodes()),
  });
};

export const useCreateHsCodeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateHsCode>[0]) =>
      CreateHsCode(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateHsCodeQueries(queryClient);
      }
    },
  });
};

export const useUpdateHsCodeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof UpdateHsCode>[0]) =>
      UpdateHsCode(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateHsCodeQueries(queryClient);
      }
    },
  });
};

export const useDeleteHsCodeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof DeleteHsCode>[0]) =>
      DeleteHsCode(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateHsCodeQueries(queryClient);
      }
    },
  });
};
